import React from "react";
import { v4 as uuidv4 } from "uuid";
import "./skillcard.css";
import skillsData from "../../data/skillsData.json";
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";

const Skills = () => {
  const skillCardAnimation = {
    hidden: {
      opacity: 0,
      y: 100,
    },

    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: "easeOut",
        staggerChildren: 0.35,
      },
    },

    exit: {
      opacity: 0,
      y: 100,
      transition: {
        duration: 1,
        ease: "easeOut",
      },
    },
  };
  return (
    <section className="skillcard">
      <Container>
        <motion.h1
          initial="hidden"
          whileInView="animate"
          exit="exit"
          variants={skillCardAnimation}
        >
          Skills & Tech Stack
        </motion.h1>
        <Container className="skill-container">
          <motion.div
            initial="hidden"
            whileInView="animate"
            exit="exit"
            variants={skillCardAnimation}
          >
            <p>
              As a fullstack developer, I possess strong tech skills in various
              areas, including programming languages such as Java and Python,
              front-end development with HTML, CSS, and JavaScript, back-end
              development using Node.js and Express, and database management
              with MySQL and MongoDB.
              <br />
              <br />
              I am proficient in Git for version control, Agile methodology for
              project management. Additionally, I have experience with machine
              learning techniques, data analysis using tools like Pandas and
              NumPy, and test automation with libraries like Selenium and Junit.
              <br />
              <br />
              Overall, I am knowledgeable in a wide range of technologies,
              constantly seeking to expand my skill set in order to stay
              up-to-date with industry trends and best practices.
            </p>
          </motion.div>
          <div>
            {skillsData.skills.map((skill) => (
              <motion.span
                initial="hidden"
                whileInView="animate"
                exit="exit"
                variants={skillCardAnimation}
                key={uuidv4()}
              >
                {skill}
              </motion.span>
            ))}
          </div>
        </Container>
      </Container>
    </section>
  );
};

export default Skills;
